<template>
  <div>
    <b-modal
      ref="select-batch-modal"
      :title="`Select ${type == 'batch' ? 'Batch' : 'Serial'}`"
      centered
      :size="type == 'batch' ? 'lg' : 'md'"
      hide-footer
      modal-class="open-selectbatch"
      @hidden="closeBatchModal"
    >
      <b-input-group class="batch-modal-search">
        <b-input-group-text slot="prepend" class="search-icon">
          <font-awesome-icon :icon="['fas', 'search']" />
        </b-input-group-text>
        <b-form-input
          type="text"
          placeholder="Enter search term"
          v-model="search"
          @input="filterData"
        >
        </b-form-input>
      </b-input-group>
      <b-row class="fs-11 cols mt-4">
        <b-col
          :md="type == 'batch' ? '3' : '6'"
          v-text="`${type == 'batch' ? 'Batch' : 'Serial'} Number`"
        />
        <b-col :md="type == 'batch' ? '1' : '6'">MRP</b-col>
        <b-col md="2" v-show="type == 'batch'">Manufacture Date</b-col>
        <b-col md="2" v-show="type == 'batch'">Expiry Date</b-col>
        <b-col md="2" v-show="type == 'batch'">Validity</b-col>
        <b-col md="2" v-show="type == 'batch'">Units available</b-col>
      </b-row>
      <ul class="custom-checklist">
        <li
          v-for="(item, index) in getOptions"
          :key="index"
          class="py-3"
          :class="{ active: selectedBatch === item.id }"
          @click="selectBatch(item)"
        >
          <b-row>
            <b-col :md="type == 'batch' ? '3' : '6'"
              ><span v-text="item.code"
            /></b-col>
            <b-col :md="type == 'batch' ? '1' : '6'"
              ><span v-text="currencySymbol + formatAmount(item.mrp)"
            /></b-col>
            <b-col md="2" v-show="type == 'batch'"
              ><span v-text="formatText(item.mfg_date)"
            /></b-col>
            <b-col md="2" v-show="type == 'batch'"
              ><span v-text="formatText(item.exp_date)"
            /></b-col>
            <b-col md="2" v-show="type == 'batch'"
              ><span v-text="formatText(item.validty)"
            /></b-col>
            <b-col md="2" v-show="type == 'batch'"
              ><span v-text="formatText(item.stock)"
            /></b-col>
          </b-row>
        </li>
      </ul>
      <div
        v-if="getOptions.length == ''"
        class="text-center d-flex justify-content-center align-items-center"
        style="min-height:200px"
      >
        No result found
      </div>
      <b-button
        variant="primary"
        class="float-right"
        type="button"
        id="confirm-selected"
        @click="updateBatch"
        :disabled="selectedBatch == '' || $loading"
      >
        <span v-if="!$loading">Confirm Selected</span>
        <b-spinner small v-if="$loading" />
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "select-batch-modal",
  components: {},
  props: ["open", "barcode", "options", "batch", "type"],
  data() {
    return {
      loading: false,
      selectedBatch: "",
      getOptions: [],
      search: "",
    };
  },
  watch: {
    open() {
      let self = this;
      if (this.open) {
        this.getOptions = this.options;
        this.selectedBatch = this.batch == "" ? this.options[0].id : this.batch;
        this.$refs["select-batch-modal"].show();
      } else {
        this.$refs["select-batch-modal"].hide();
      }
    },
    search() {
      if (this.search == "") this.getOptions = this.options;
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },

  methods: {
    filterData() {
      // this.getOptions = [];
      let search_term = new RegExp(this.search.toLowerCase());
      this.getOptions = this.options.filter((item) => {
        if (search_term.test(item.code.toLowerCase())) return item;
      });
    },
    closeBatchModal() {
      this.$emit("close-batch-modal", false);
    },
    selectBatch(data) {
      this.selectedBatch = data.id;
    },
    updateBatch() {
      let update = {
        batch_data: this.selectedBatch,
        barcode: this.barcode,
        type: this.type,
      };
      this.$emit("update-batch", update);
    },
  },
};
</script>
<style lang="scss" scoped>
.cols {
  padding-left: 30px;
  color: $dark-card-text;
}
.custom-checklist {
  li {
    padding-left: 40px;
    margin-left: -10px;
    &:before {
      left: 11px;
    }
    &:after {
      left: 16px;
    }
  }
}
</style>
